import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import history from 'history.js'
import routes from './RootRoutes'
import { GlobalCss, MatxSuspense, MatxTheme, MatxLayout } from 'app/components'
import sessionRoutes from './views/sessions/SessionRoutes'
import { SettingsProvider } from 'app/contexts/SettingsContext'

import 'toastr/build/toastr.min.js'
import 'toastr/build/toastr.css'

import {
    primeiroDiaMesAtual,
    ultimoDiaMesAtual,
} from './business-components/Date/Date'

import camposConsorcioList from './business-rules/List/Consorcio/camposConsorcioList'

import camposFunilEtapaList from './business-rules/List/Dashboard/camposFunilEtapaList'

import camposTipoPendenciaList from './business-rules/List/Dashboard/camposTipoPendenciaList'

import camposPatrimonioImobilizadoList from './business-rules/List/Dashboard/camposPatrimonioImobilizadoList'

import camposRecursosFinanceirosList from './business-rules/List/Dashboard/camposRecursosFinanceirosList'

import camposPropostaList from './business-rules/List/SeguroVida/camposPropostaList'

import camposApoliceList from './business-rules/List/SeguroVida/camposApoliceList'

import camposApoliceCoberturaList from './business-rules/List/SeguroVida/camposApoliceCoberturaList'

import camposApoliceCobrancaList from './business-rules/List/SeguroVida/camposApoliceCobrancaList'

import camposApoliceComissaoList from './business-rules/List/SeguroVida/camposApoliceComissaoList'

import camposUsuarioEstatisticaList from './business-rules/List/camposUsuarioEstatisticaList'

import camposClienteAgenteList from './business-rules/List/camposClienteAgenteList'

import {
    inicializaControleDashboard,
} from './views/dashboard/dashboardComponents/DashboardService'



const App = () => {

    let variaveisGlobais = {
        configuracaoUsuario: undefined,
        equipeList: undefined,
        acessoCliente: false,
        acessoClienteChaves: {},
        clienteSelecionado: undefined,
        ultimaVersaoClienteSelecionado: undefined,
        jsonComparacaoEstudosClienteSelecionado: undefined,
        versaoSelecionada: undefined,
        usuarioClienteSelecionado: undefined,
        usuarioClienteSelecionadoIdentificacao: undefined,
        exibirListaAgenda: true,
        exibirListaPendenciasComDataPrevista: true,
        exibirListaAniversario: true,
        exibirListaAporte: true,
        dashboardFamilia: inicializaControleDashboard(null, null, null, false, ''),
        dashboardFunilEtapa: inicializaControleDashboard(null, 'dataHoraInclusaoFunilEtapa', camposFunilEtapaList, false, 'funilEtapaAtual'),
        dashboardPendencia: inicializaControleDashboard(null, null, camposTipoPendenciaList, false, 'pendente'),
        dashboardConsorcio: inicializaControleDashboard('dataAssembleia', null, camposConsorcioList, false, ''),
        dashboardProjetoVidaSonho: inicializaControleDashboard(null, null, null, false, ''),
        dashboardPatrimonioImobilizado: inicializaControleDashboard(null, null, camposPatrimonioImobilizadoList, false, ''),
        dashboardRecursosFinanceiros: inicializaControleDashboard(null, null, camposRecursosFinanceirosList, false, ''),
        dashboardProposta: inicializaControleDashboard('dataAssinatura', null, camposPropostaList, false, ''),
        dashboardApolice: inicializaControleDashboard('dataEmissao', null, camposApoliceList, false, 'producaoPropria'),
        dashboardApoliceCobertura: inicializaControleDashboard('dataEmissao', null, camposApoliceCoberturaList, false, 'producaoPropria'),
        dashboardApoliceCobranca: inicializaControleDashboard('dataVencimento', null, camposApoliceCobrancaList, true, 'producaoPropria'),
        dashboardApoliceComissao: inicializaControleDashboard('dataGeracaoComissao', null, camposApoliceComissaoList, false, ''),
        dashboardUsuarioEstatistica: inicializaControleDashboard(null, null, camposUsuarioEstatisticaList, false, ''),
        dashboardClienteAgente: inicializaControleDashboard(null, null, camposClienteAgenteList, false, ''),
        dataInicialAporte: primeiroDiaMesAtual(),
        dataFinalAporte: ultimoDiaMesAtual(),
        exibirStatusAportePendente: true,
        exibirStatusAporteNaoRealizado: false,
        exibirStatusAporteRealizado: false,
        filtroIntegracao: {
            tipoArquivo: '',
            instituicaoFinanceira: '',
            statusProcessamento: '',
        },
    }

    return (
        <AppContext.Provider value={{ variaveisGlobais, routes }}>
            <SettingsProvider>
                <MatxTheme>
                    <GlobalCss />
                    <Router history={history}>
                        <MatxSuspense>
                            <Switch>
                                {sessionRoutes.map((item, i) => (
                                    <Route
                                        key={i}
                                        path={item.path}
                                        component={item.component}
                                    />
                                ))}
                                <MatxLayout
                                    variaveisGlobais={variaveisGlobais}
                                />{' '}
                            </Switch>
                        </MatxSuspense>
                    </Router>
                </MatxTheme>
            </SettingsProvider>
        </AppContext.Provider>
    )
}

export default App